export default {"src":"/_next/static/media/tik-tok.6994aeff.svg","height":37,"width":38,"blurWidth":0,"blurHeight":0};